// import { initColorMode } from "./theme/colorMode"; // TODO: activate Darkmode

import changeEventForInput from "./helper/autofill-events";
import animateContentOnScroll from "./helper/animate-content-on-scroll";

// import { scrollToID } from "./helper/helper";
import {
  initToggleDropdown,
  disableEmptyNavLinks,
} from "./partials/mb-navigation";
import { initNavIcon } from "./partials/mb-nav-icon";
import { initMbModal } from "./partials/mb-modal";
import { configLibraries } from "./theme/configLibraries";
import { linkWrapperClickHandler, initWatchHover } from "./theme/clickHandler";
import { initReadmore, updateReadMore } from "./partials/mb-readmore";
import { initJobSelect } from "./partials/add-jobs-to-jobselect";
// import { mbYoutubeBorlabsGate } from "./partials/mb-youtube-borlabs-gate";
import { initBreadcrumbColor } from "./partials/breadcrumb";

import { printDeveloperMessageToConsole } from "./helper/mbagentur";

import { cf7MailSentHandler } from "./partials/mb-cf7MailSentHandler";
// import { initHeroViedeo } from "./partials/mb-hero";

/**
 * Init JS Helper
 */
changeEventForInput();

(function () {
  function init() {
    // // Get styling informations from css property values
    // const style = getComputedStyle(document.body);
    // const max_mainwidth = style.getPropertyValue("--maxMainWidth");

    // // TODO: activate Darkmode
    // initColorMode();

    initNavIcon();
    initToggleDropdown();
    disableEmptyNavLinks();
    configLibraries();
    linkWrapperClickHandler();
    initWatchHover();
    animateContentOnScroll();
    initMbModal();
    initReadmore();
    initJobSelect();
    initBreadcrumbColor();  
    // mbYoutubeBorlabsGate();

    printDeveloperMessageToConsole();

    cf7MailSentHandler(".wpcf7-form");

    // initHeroViedeo();
  }

  init();

  // On document ready
  docReady(function (context) {});
})();

/**
 * Smooth Anker scrolling
 */
// jQuery('a[href*="#"]').on("click", function (e) {
//   const target = this.hash;
//   if (scrollToID(target, -50)) {
//     e.preventDefault();
//   }
// });

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    // Aktuellen Pfad und Hash vergleichen
    if (
      window.location.pathname === this.pathname &&
      window.location.hostname === this.hostname
    ) {
      const targetId = this.hash.slice(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        e.preventDefault();
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
    // Falls nicht: Browser-Standardverhalten (Seitenwechsel oder nichts)
  });
});

/**
 * Document resize listener
 */
window.addEventListener("resize", (event) => {
  updateReadMore();
});

/**
 * Scroll top button
 */
// let topbtn = document.getElementById("topbutton");

// window.addEventListener("scroll", function () {
//   if (window.scrollY > 300 && topbtn) {
//     topbtn.classList.add('show');
//   } else if (topbtn) {
//     topbtn.classList.remove('show');
//   }
// });

// topbtn.addEventListener("click", function (e) {
//   e.preventDefault();
//   window.scroll({
//     top: 0,
//     left: 0,
//     behavior: 'smooth'
//    });
// });

// add class scroll to main menu on scrolling
jQuery(window).scroll(function() {
  var scroll = jQuery(window).scrollTop();

  if (scroll >= 1) {
      jQuery("#mb-section-main-menu").addClass("scrolling");
  } else {
      jQuery("#mb-section-main-menu").removeClass("scrolling");
  }
});
